module.exports = __webpack_public_path__ + "img/Yellow-R-2@2x.f74a88a0.png";